export default "__VITE_ASSET__BUPh2_Tj__"